import React from 'react';
import { ForgeListItem, ForgeTooltip } from '@tylertech/forge-react';

export interface ActionItemProps {
  label: string;
  /**
   * NOTE: if this and `href` are empty, then nothing will happen when you click on this action.
   */
  onClick?: () => void;
  toolTipText?: string;
  /**
   * Added to the link element, when it is enabled.
   * NOTE: if this and `onClick` are empty, then nothing will happen when you click on this action.
   */
  href?: string;
  target?: string;
}

export const ActionItem = ({ label, onClick, toolTipText, href, target }: ActionItemProps) => {
  const isDisabled = !!toolTipText;
  if (href) {
    return (
      <ForgeListItem>
        <a href={href} target={target}>
          {label}
        </a>
      </ForgeListItem>
    );
  }

  return (
    <ForgeListItem>
      <button disabled={isDisabled} onClick={onClick}>
        {label}
        {isDisabled && <ForgeTooltip placement="right">{toolTipText}</ForgeTooltip>}
      </button>
    </ForgeListItem>
  );
};
